import '../styles/Header.css'

function Header({children, withDatas}){
	return <div datas={withDatas} className="sticky-header">{children}</div>
}

export default Header